import React from "react";

const Percentage = props => {
  if (props.value == null) {
    return <span>- %</span>;
  }

  return <span>{props.value}%</span>;
};

export default Percentage;
